import React, { useState } from 'react';
import { Box, Button, FormField, Input, Modal, SpaceBetween } from '@amzn/awsui-components-react-v3';
import { associateTemplateToResources } from 'src/api/permissions';
import { ResourceSelector } from 'src/components/common/resourceSelector/resourceSelector';
import { TEMPLATE_TYPE_ACCESS_REQUEST_WORKFLOW } from 'src/commons/constants';
import { ResourceType } from 'src/components/common/resourceSelector/common';

export interface AssociateTemplateModalProps {
  templateId: string;
  setNotification: (header: any, message: string) => void;
  close: () => void;
  visible: boolean;
  activeGroup?: string;
  activeWorkspace?: any;
  handleRefresh?: () => void;
  templateType?: string;
}

export const AssociateTemplateModal = (props: AssociateTemplateModalProps) => {
  const [buttonLoading, setButtonLoading] = useState(false);
  const [resourceId, setResourceId] = useState(null);
  const [resourceType, setResourceType] = useState(null);
  const [selectedResource, setSelectedResource] = useState(null);

  const handleAssociateResource = async () => {
    setButtonLoading(true);
    try {
      let resourceOwnerId = undefined;
      if (resourceType == ResourceType.GOVERNANCE_TAG) {
        // For HC business glossary - governance tag, resourceOwnerId is required for associateTemplateToResources API
        resourceOwnerId = selectedResource.OwnerId;
      }
      await associateTemplateToResources({
        templateId: props.templateId,
        resourceId: resourceId,
        resourceOwnerId: resourceOwnerId,
      });
      props.setNotification('success', `Template is associated with resource : ${resourceId}`);
      props.handleRefresh();
    } catch (err) {
      props.setNotification('error', `Failed to associate with resource ID: ${resourceId}, cause: ${err.message}`);
    }
    props.close();
    resetToDefault();
    setResourceId('');
    setButtonLoading(false);
  };

  const clearSelectedOptions = () => {
    setResourceId(null);
  };

  const resetToDefault = () => {
    clearSelectedOptions();
  };

  const enableAssociateButton = () => {
    return resourceId != null;
  };

  return (
    <Modal
      onDismiss={() => {
        resetToDefault();
        props.close();
      }}
      visible={props.visible}
      size='medium'
      footer={
        <Box float='right'>
          <SpaceBetween direction='horizontal' size='xs'>
            <Button
              variant='link'
              onClick={() => {
                resetToDefault();
                props.close();
              }}
            >
              Cancel
            </Button>
            <Button
              variant='primary'
              disabled={!enableAssociateButton()}
              onClick={handleAssociateResource}
              loading={buttonLoading}
            >
              {'Associate'}
            </Button>
          </SpaceBetween>
        </Box>
      }
      header='Associate resource to template'
    >
      <FormField label={'Template ID'}>
        <Input ariaRequired={true} value={props.templateId} readOnly={true} disabled />
      </FormField>
      <ResourceSelector
        {...props}
        setNotification={props.setNotification}
        onSelect={(resourceId) => setResourceId(resourceId)}
        onResourceSelect={(resource) => setSelectedResource(resource)}
        onResourceTypeSelect={(rType) => setResourceType(rType)}
        disableGroupAndWorkspaceSelection={false}
        disableTagSelection={false}
        disableMetadataFormSelection={true}
        disableCatalogSelection={false}
        disableGovernanceTagSelection={
          props.templateType ? props.templateType != TEMPLATE_TYPE_ACCESS_REQUEST_WORKFLOW : true
        }
      />
    </Modal>
  );
};
